export default __webpack_public_path__ + "static/media/gardenofAIden.ea45c50e.png";